/**
 * @generated SignedSource<<c49622331b3d7750ce8d5e4b34b7ed85>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IconCell$data = {
  readonly id: string;
  readonly issueType: {
    readonly avatar: {
      readonly small: string | null | undefined;
    } | null | undefined;
    readonly name: string;
  } | null | undefined;
  readonly " $fragmentType": "IconCell";
};
export type IconCell$key = {
  readonly " $data"?: IconCell$data;
  readonly " $fragmentSpreads": FragmentRefs<"IconCell">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IconCell",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraAvatar",
          "kind": "LinkedField",
          "name": "avatar",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "small"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraIssueTypeField"
};

(node as any).hash = "08d51c88eaef04241b1eefa353f8f767";

export default node;
